import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormedEltTranslation } from '../../../../helpers/getFormedEltTranslation'
import { NoteWrapper } from '../../../styledComponents/notes/noteWrapper/NoteWrapper'
import { TopicAreaNote } from '../../../styledComponents/notes/TopicAreaNote'

export const getTopicAreaThView = () => {
  return (
    <div>
      <NoteWrapper noteContent={TopicAreaNote}>
        <div>
          <Translation text={getFormedEltTranslation('support-table-topic-area')} />
        </div>
      </NoteWrapper>
    </div>
  )
}
